var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCharts = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
})));
export { SvgCharts as ReactComponent };
export default __webpack_public_path__ + "static/media/charts.6da023c985c579bcadc2e796e6be308c.svg";